import Vue from "vue";
import Vuetify from "vuetify/lib";
import pl from "vuetify/es5/locale/pl";
import automatic_production from "@/components/icons/automatic_production.vue";
import modernization_machinery_control from "@/components/icons/modernization_machinery_control.vue";
import ce from "@/components/icons/ce.vue";
import prefabrication from "@/components/icons/prefabrication.vue";
import info from "@/components/icons/info.vue";
import cooperation from "@/components/icons/cooperation.vue";
import realizations from "@/components/icons/realizations.vue";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pl },
    current: "pl",
  },
  icons: {
    values: {
      automatic_production: {
        component: automatic_production,
      },
      modernization_machinery_control: {
        component: modernization_machinery_control,
      },
      ce: {
        component: ce,
      },      
      prefabrication: {
        component: prefabrication,
      },
      info: {
        component: info,
      },
      cooperation: {
        component: cooperation,
      },      
      realizations: {
        component: realizations,
      },
    },
  },
});
